import Register from './register'
import Info from './info'

export default  {
  register: <Register/>,
  info: <Info/>,
}

